module.exports = __webpack_public_path__ + "static/media/msg.49ee75e3.svg";